export const VENMO_PAYMENT_STATUS = {
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
} as const;

export const VENMO_ERRORS = {
  INITIALIZATION_FAILED: 'Failed to initialize Venmo',
  TOKENIZATION_FAILED: 'Failed to tokenize Venmo payment',
  INVALID_ADDRESS: 'Invalid address provided',
} as const;
